import { AppEntity, ContactInformationSchema, PostalAddressSchema } from '@app/icare/db/schema/common'
import { entityId } from '@pkg/db/schema'
import { z } from 'zod'

export const HospiceId = entityId('hospice')

export type HospiceIdType = typeof HospiceId.Type

export const HospiceSchema = AppEntity.extend({
  id: HospiceId.schema,
  name: z.string().min(1).max(255).default(''),
  comment: z.string().nullish(),
  remarks: z.string().nullish(),
  serviceArea: z.string().max(255).nullish(),
  address: PostalAddressSchema.nullish(),
  contact: ContactInformationSchema.nullish(),
})

export type Hospice = z.infer<typeof HospiceSchema>
